import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Link } from 'react-router-dom';

const caseStudies = [
  {
    subtitle: "Information Technology",
    image: "assets/img/industry/Information_technology.png",
    description: "The IT industry thrives on innovation, scalability, and speed — and so do we.",
    myurl: "/Information-Technology",
  },
  {
    subtitle: "Pharmaceutical Industry",
    image: "assets/img/industry/pharmaceutical_industry.png",
    description: "In the ever-evolving pharmaceutical sector, precision, compliance, and expertise are everything.",
    myurl: "/Pharmaceutical",
  },
  {
    subtitle: "Non-Banking Financial Companies (NBFCs)",
    image: "assets/img/industry/non-banking_financial_companies_(NBFCs).png",
    description: "The NBFC sector in India is growing rapidly and demands finance professionals who are not only skilled but also.",
    myurl: "/NBFCs",
  },
  {
    subtitle: "Direct Selling Agents (DSA)",
    image: "assets/img/industry/direct_selling_agents_(DSA).png",
    description: "In the fast-paced world of Direct Selling Agents (DSAs), performance, communication, and motivation are key drivers.",
    myurl: "/DSA",
  },
  {
    subtitle: "Real Estate Sector",
    image: "assets/img/industry/real_estate_sector.png",
    description: "The real estate sector requires a unique blend of market insight, negotiation skills, and customer trust.",
    myurl: "/Real_State_Sector",
  },
];

const OurIndustries = () => {
  return (
    <div className="case1-section sp1">
      <div className="container">
        {/* Header */}
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="heading1 space-margin60">
              <h5 className="vl-section-subtitle">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18">
                  <path
                    d="M9.45 17.8772C14.2115 17.6442 18 13.7338 18 8.94408C18 7.4743 17.6433 6.08732 17.0111 4.86399C14.4764 6.3183 13.2091 7.04546 12.2507 8.02546C11.1061 9.19582 10.2724 10.6308 9.82481 12.201C9.45 13.5159 9.45 14.9697 9.45 17.8772Z"
                    fill="#FB8500"
                  />
                  <path
                    d="M8.55 17.8772C3.78851 17.6442 0 13.7338 0 8.94408C0 7.47429 0.356744 6.08731 0.988876 4.86398C3.52358 6.3183 4.79093 7.04546 5.74937 8.02547C6.89397 9.19583 7.72761 10.6308 8.17521 12.2011C8.55 13.5159 8.55 14.9697 8.55 17.8772Z"
                    fill="#FB8500"
                  />
                  <path
                    d="M1.43959 4.08981C3.97405 5.54399 5.24127 6.27107 6.57492 6.60594C8.16664 7.00559 9.83338 7.00559 11.4251 6.60594C12.7587 6.27108 14.026 5.54399 16.5604 4.08982C14.9571 1.62862 12.1699 0 9 0C5.8301 0 3.04295 1.62862 1.43959 4.08981Z"
                    fill="#FB8500"
                  />
                </svg>{' '}
                Industry We Serve
              </h5>
              <div className="space16" />
              <h2 className="vl-section-title">
                Empowering Every Industry with Tailored Talent Solutions
              </h2>
              <div className="space16" />
              <p className="homge_Services_oneLIne">
                From IT to Real Estate, we deliver industry-specific HR expertise that drives growth, innovation, and lasting success.
              </p>
            </div>
          </div>
          <div className="col-lg-6 text-end  d-lg-block">
            {/* Swiper navigation buttons */}
            <div className="swiper-nav-buttons testimonial-arrow text-end">
              <div className="swiper-button-prev-custom">
                  <div className="prev-arrow">
                <button className="testimonial-arrow">
                  <i className="fa-solid fa-arrow-left"></i>
                </button>
              </div>
              </div>
              <div className="swiper-button-next-custom">
                  <div className="next-arrow">
                <button  >
                  <i className="fa-solid fa-arrow-right"></i>
                </button>
              </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slider */}
        <div className="row mt-4">
          <div className="col-lg-12">
            <Swiper
              modules={[Navigation, Pagination,Autoplay]}
              spaceBetween={30}
              slidesPerView={3}
              loop={true}
              autoplay={{
                        delay: 3000, // 3 seconds
                        disableOnInteraction: false,
                      }}
              navigation={{
                nextEl: '.swiper-button-next-custom',
                prevEl: '.swiper-button-prev-custom',
              }}
              pagination={{ clickable: true }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                992: {
                  slidesPerView: 3,
                },
              }}
            >
              {caseStudies.map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="case-boxes-area">
                    <div className="img1">
                      <img src={item.image} alt={item.subtitle} className="img-fluid" />
                    </div>
                    <div className="text-area1">
                      <h5>{item.subtitle}</h5>
                      <div className="space16" />
                      <p>{item.description}</p>
                      <div className="arrow mt-2">
                        <Link to={item.myurl}>
                          <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurIndustries;
